enum DefinedContributionDownshiftingInfo {
  UNDERINVESTERING = 'UNDERINVESTERING',
  INVESTERING = 'INVESTERING',
  UNDERNEDVEKTING = 'UNDERNEDVEKTING',
  NEDVEKTING = 'NEDVEKTING',
  UNDEFINED = 'UNDEFINED',
}

export default DefinedContributionDownshiftingInfo;
